import {useLayoutEffect,useRef} from 'react'

export function conversationViewportFrame(viewport,layoutHeight) {
  const height=viewport?.height,scale=viewport?.scale,offsetTop=viewport?.offsetTop
  if(!Number.isFinite(layoutHeight)||layoutHeight<=0||!Number.isFinite(height)||height<=0
    ||!Number.isFinite(scale)||Math.abs(scale-1)>0.001||!Number.isFinite(offsetTop)
    ||height>=layoutHeight-1)return null
  return {height,top:Math.max(0,Math.min(offsetTop,layoutHeight-height))}
}

// Only a focused conversation composer opts into the visible keyboard viewport.
// The surrounding application and its other menus keep their ordinary layout.
export default function useConversationViewport({active,identity,containerRef}) {
  const identityRef=useRef(identity)
  identityRef.current=identity
  useLayoutEffect(()=>{
    const viewport=window.visualViewport
    if(!active||!viewport)return undefined
    let current=true,frame=null,original=null
    const restore=()=>{
      if(!original)return
      const {node,properties}=original
      for(const [name,{value,priority}] of properties){
        if(value)node.style.setProperty(name,value,priority)
        else node.style.removeProperty(name)
      }
      original=null
    }
    const measure=()=>{
      frame=null
      if(!current||identityRef.current!==identity)return
      const node=containerRef.current
      const composer=document.activeElement
      const focused=composer?.tagName==='TEXTAREA'&&composer.getAttribute('data-chat-composer')==='true'&&node?.contains(composer)
      const value=focused?conversationViewportFrame(viewport,document.documentElement.clientHeight||window.innerHeight):null
      if(!value){restore();return}
      if(original?.node!==node)restore()
      // The fitted viewport already ends above the keyboard. Keeping the
      // device's bottom safe area here would reserve the home-indicator space
      // a second time between the composer and the keyboard.
      const styles={position:'fixed',top:`${value.top}px`,height:`${value.height}px`,left:'0px',right:'0px',width:'100%','max-width':'430px','margin-left':'auto','margin-right':'auto','--hubbing-chat-bottom-inset':'0px'}
      if(!original)original={node,properties:new Map(Object.keys(styles).map(name=>[name,{value:node.style.getPropertyValue(name),priority:node.style.getPropertyPriority(name)}]))}
      for(const [name,value] of Object.entries(styles))if(node.style.getPropertyValue(name)!==value)node.style.setProperty(name,value)
    }
    const schedule=()=>{
      if(frame!==null||!current)return
      if(typeof window.requestAnimationFrame==='function')frame=window.requestAnimationFrame(measure)
      else measure()
    }
    measure()
    viewport.addEventListener('resize',schedule)
    viewport.addEventListener('scroll',schedule)
    window.addEventListener('resize',schedule)
    document.addEventListener('focusin',schedule)
    document.addEventListener('focusout',schedule)
    return()=>{
      current=false
      if(frame!==null)window.cancelAnimationFrame?.(frame)
      viewport.removeEventListener('resize',schedule)
      viewport.removeEventListener('scroll',schedule)
      window.removeEventListener('resize',schedule)
      document.removeEventListener('focusin',schedule)
      document.removeEventListener('focusout',schedule)
      restore()
    }
  },[active,identity,containerRef])
}
